<template>
  <v-container fluid fill-height text-xs-center>
    <v-layout row wrap align-center justify-center>
      <v-flex xs10 offset-xs-1 sm10 offset-1 md5 offset-md-2 lg3 offset-lg-2>
        <v-card class="rounded">
          <div class="pa-3">
            <v-img
              :src="require('@/assets/img/logo-Ovation.v3.png')"
              contain
              height="120px"
            ></v-img>
          </div>
          <v-card-text>
            <div class="title">Welcome to Ovation App!</div>
            <hr class="my-2" />
            <p class="my-2">
              By logging into this application you agree to our
            </p>
            <div>
              <a
                target="_blank"
                href="https://ovation-uploads.s3.us-east-2.amazonaws.com/common/Ovation-Terms-of-Service.pdf"
                >Terms and Conditions</a
              >
            </div>
          </v-card-text>
          <v-card-actions class="justify-center">
            <v-btn
              color="#d13b55"
              class="btn-rounded-medium white--text"
              @click.prevent="auth0Login()"
            >
              Login
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <div style="position: absolute; bottom: 50px; left: 50px; color: #888">
      <span>{{ $store.state.appVersion }}</span>
    </div>
  </v-container>
</template>

<script>
export default {
  name: "Login",
  methods: {
    auth0Login() {
      this.$store.dispatch("auth0Login");
    },
  },
  beforeMount() {},
  mounted() {
    var that = this;
    setTimeout(function () {
      that.auth0Login();
    }, 10);
  },
};
</script>
